import i18n from '@/plugins/i18n';
import {
  CAPABILITY_APM,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
  CAPABILITY_VM,
} from '@/utils/constants';

export const ChartLineCustom = 'ChartLineCustom';
export const ApexChartBar = 'ApexChartBar';
export const ApexChartAreaCustom = 'ApexChartAreaCustom';
export const ApexChartArea = 'ApexChartArea';
export const ApexChartLine = 'ApexChartLine';
export const SummaryMetric = 'SummaryMetric';
export const MultilineGraph = 'MultiLineGraph';

const customGraphAndSummaryTypes = [
  ChartLineCustom,
  ApexChartBar,
  ApexChartAreaCustom,
  ApexChartArea,
  ApexChartLine,
  SummaryMetric,
  MultilineGraph,
];

const TABLE_PAGE_SIZE = 30;

const STATUS_LABEL = 'StatusLabel';
const TABLE_WIDGET = 'TableWidget';

export const APPLICATION_SUMMARY = 'APPLICATION_SUMMARY';
export const VM_SUMMARY = 'VM_SUMMARY';
export const MAX_SERVICES_FOR_SUMMARY_METRIC = 5;

export const capabilityLabelMap = {
  [CAPABILITY_APM]: CAPABILITY_APM,
  [CAPABILITY_BROWSER]: CAPABILITY_BROWSER,
  [CAPABILITY_MOBILE]: CAPABILITY_MOBILE,
  [CAPABILITY_VM]: CAPABILITY_VM,
};

export const capabilityIconNameMap = {
  [CAPABILITY_APM]: 'apm',
  [CAPABILITY_BROWSER]: 'browser',
  [CAPABILITY_MOBILE]: 'mobile',
  [CAPABILITY_VM]: 'vm',
};

const metricLabels = [
  {
    name: i18n.global.t('applicationSummary'),
    id: APPLICATION_SUMMARY,
  },
  {
    name: i18n.global.t('vmSummary'),
    id: VM_SUMMARY,
  },
];

const summaryMetricCapabilityList = [
  {
    label: i18n.global.t('apmLabel'),
    key: CAPABILITY_APM,
  },
  {
    label: i18n.global.t('browserMonitoring'),
    key: CAPABILITY_BROWSER,
  },
  {
    label: i18n.global.t('mobileMonitoring'),
    key: CAPABILITY_MOBILE,
  },
];

const vmCapabilityObj = {
  label: i18n.global.t('vmCapability'),
  key: CAPABILITY_VM,
};

const defaultCapabilityObj = {
  label: i18n.global.t('selectCapability'),
  key: 'selectCapability',
};

export const TIME_FORMAT = 'TIME';
export const COUNT_FORMAT = 'COUNT';
export const PERCENTAGE_FORMAT = 'PERCENTAGE';
export const APM_SERVICE_APDEX = 'service_apdex_avg';
export const BM_SERVICE_APDEX = 'browser_app_apdex_avg';
export const VM_AVAILABILITY_STATUS = 'status';

export const APDEX_FAIR_LIMIT = 0.83;
export const APDEX_POOR_LIMIT = 0.68;
export const REDIRECT_TO_ALERTS = 'ALERTS';

const smryMetricKeyLabelMapper = {
  // Response time
  service_resp_time_avg: {
    label: i18n.global.t('avgRespTime'),
    dataFormat: TIME_FORMAT,
  },
  browser_app_resp_time_avg: {
    label: i18n.global.t('avgRespTime'),
    dataFormat: TIME_FORMAT,
  },
  mobile_app_perf_response_time_avg: {
    label: i18n.global.t('avgRespTime'),
    dataFormat: TIME_FORMAT,
  },
  // Total calls Metric
  service_total_call_sum: {
    label: i18n.global.t('totalCalls'),
    dataFormat: COUNT_FORMAT,
  },
  browser_app_pv_sum: {
    label: i18n.global.t('totalCalls'),
    dataFormat: COUNT_FORMAT,
  },
  mobile_app_normal_count_sum: {
    label: i18n.global.t('totalCalls'),
    dataFormat: COUNT_FORMAT,
  },
  // Calls per min
  service_total_call_permin: {
    label: i18n.global.t('callsPerMins'),
    dataFormat: COUNT_FORMAT,
  },
  browser_app_pv_permin: {
    label: i18n.global.t('callsPerMins'),
    dataFormat: COUNT_FORMAT,
  },
  mobile_app_normal_count_permin: {
    label: i18n.global.t('callsPerMins'),
    dataFormat: COUNT_FORMAT,
  },
  // Total errors
  service_error_count_sum: {
    label: i18n.global.t('totalErrors'),
    dataFormat: COUNT_FORMAT,
  },
  browser_app_error_sum_sum: {
    label: i18n.global.t('totalErrors'),
    dataFormat: COUNT_FORMAT,
  },
  mobile_app_perf_error_sum_sum: {
    label: i18n.global.t('totalErrors'),
    dataFormat: COUNT_FORMAT,
  },
  // Errors per min
  service_error_count_permin: {
    label: i18n.global.t('errorsPerMin'),
    dataFormat: COUNT_FORMAT,
  },
  browser_app_error_sum_permin: {
    label: i18n.global.t('errorsPerMin'),
    dataFormat: COUNT_FORMAT,
  },
  mobile_app_perf_error_sum_permin: {
    label: i18n.global.t('errorsPerMin'),
    dataFormat: COUNT_FORMAT,
  },
  //  Total alerts triggered
  alert_count: {
    label: i18n.global.t('totalAlertsTriggered'),
    dataFormat: COUNT_FORMAT,
    redirectTo: REDIRECT_TO_ALERTS,
  },

  // CPU %
  windows_vm_cpu_usage_percentage_avg: {
    label: i18n.global.t('cpuUsageWithoutPct'),
    dataFormat: PERCENTAGE_FORMAT,
    aggregationNum: 100,
  },
  meter_vm_cpu_utilization_avg: {
    label: i18n.global.t('cpuUsageWithoutPct'),
    dataFormat: PERCENTAGE_FORMAT,
    aggregationNum: 100,
  },
  // Memory %
  windows_vm_memory_used_percentage_avg: {
    label: i18n.global.t('memoryUsage'),
    dataFormat: PERCENTAGE_FORMAT,
  },
  meter_vm_memory_used_percentage_avg: {
    label: i18n.global.t('memoryUsage'),
    dataFormat: PERCENTAGE_FORMAT,
  },
  // Disk usage
  windows_vm_disk_utility_used_percentage_avg: {
    label: i18n.global.t('diskUsage'),
    dataFormat: PERCENTAGE_FORMAT,
  },
  meter_vm_total_filesystem_used_percentage_avg: {
    label: i18n.global.t('diskUsage'),
    dataFormat: PERCENTAGE_FORMAT,
  },
};

const multilineGraphFormulaMapper = {
  roundUpToThreeDecimal: (value) => parseFloat(value).toFixed(3),
  aggregateBy10000: (value) => parseFloat(value / 10000).toFixed(3),
  toMB: (value) => parseFloat(value / 1048576).toFixed(3),
};

export {
  customGraphAndSummaryTypes,
  TABLE_PAGE_SIZE,
  STATUS_LABEL,
  TABLE_WIDGET,
  metricLabels,
  summaryMetricCapabilityList,
  vmCapabilityObj,
  smryMetricKeyLabelMapper,
  defaultCapabilityObj,
  multilineGraphFormulaMapper,
};
